<template>
  <div id="Reportes">
    <b-row>
      <b-col md="4">
        <reporte-utilidades></reporte-utilidades>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import reporteUtilidades from "./reporteUtilidades.vue";
export default {
  components: { reporteUtilidades },
};
</script>